__turbopack_context__.v({
  "arrow": "ArticleCarousel-module-scss-module___EIiwG__arrow",
  "caption": "ArticleCarousel-module-scss-module___EIiwG__caption",
  "carousel": "ArticleCarousel-module-scss-module___EIiwG__carousel",
  "container": "ArticleCarousel-module-scss-module___EIiwG__container",
  "controls": "ArticleCarousel-module-scss-module___EIiwG__controls",
  "counter": "ArticleCarousel-module-scss-module___EIiwG__counter",
  "image": "ArticleCarousel-module-scss-module___EIiwG__image",
  "imageWrap": "ArticleCarousel-module-scss-module___EIiwG__imageWrap",
  "slide": "ArticleCarousel-module-scss-module___EIiwG__slide",
  "stack-module-0": "ArticleCarousel-module-scss-module___EIiwG__stack-module-0",
  "stack-module-1": "ArticleCarousel-module-scss-module___EIiwG__stack-module-1",
  "stack-module-10": "ArticleCarousel-module-scss-module___EIiwG__stack-module-10",
  "stack-module-11": "ArticleCarousel-module-scss-module___EIiwG__stack-module-11",
  "stack-module-12": "ArticleCarousel-module-scss-module___EIiwG__stack-module-12",
  "stack-module-13": "ArticleCarousel-module-scss-module___EIiwG__stack-module-13",
  "stack-module-14": "ArticleCarousel-module-scss-module___EIiwG__stack-module-14",
  "stack-module-15": "ArticleCarousel-module-scss-module___EIiwG__stack-module-15",
  "stack-module-16": "ArticleCarousel-module-scss-module___EIiwG__stack-module-16",
  "stack-module-17": "ArticleCarousel-module-scss-module___EIiwG__stack-module-17",
  "stack-module-18": "ArticleCarousel-module-scss-module___EIiwG__stack-module-18",
  "stack-module-19": "ArticleCarousel-module-scss-module___EIiwG__stack-module-19",
  "stack-module-2": "ArticleCarousel-module-scss-module___EIiwG__stack-module-2",
  "stack-module-20": "ArticleCarousel-module-scss-module___EIiwG__stack-module-20",
  "stack-module-3": "ArticleCarousel-module-scss-module___EIiwG__stack-module-3",
  "stack-module-4": "ArticleCarousel-module-scss-module___EIiwG__stack-module-4",
  "stack-module-5": "ArticleCarousel-module-scss-module___EIiwG__stack-module-5",
  "stack-module-6": "ArticleCarousel-module-scss-module___EIiwG__stack-module-6",
  "stack-module-7": "ArticleCarousel-module-scss-module___EIiwG__stack-module-7",
  "stack-module-8": "ArticleCarousel-module-scss-module___EIiwG__stack-module-8",
  "stack-module-9": "ArticleCarousel-module-scss-module___EIiwG__stack-module-9",
  "viewport": "ArticleCarousel-module-scss-module___EIiwG__viewport",
  "wrapper": "ArticleCarousel-module-scss-module___EIiwG__wrapper",
  "z-base": "ArticleCarousel-module-scss-module___EIiwG__z-base",
  "z-content": "ArticleCarousel-module-scss-module___EIiwG__z-content",
  "z-footer": "ArticleCarousel-module-scss-module___EIiwG__z-footer",
  "z-header": "ArticleCarousel-module-scss-module___EIiwG__z-header",
  "z-hero": "ArticleCarousel-module-scss-module___EIiwG__z-hero",
  "z-logo": "ArticleCarousel-module-scss-module___EIiwG__z-logo",
  "z-logo-effect": "ArticleCarousel-module-scss-module___EIiwG__z-logo-effect",
  "z-navigation": "ArticleCarousel-module-scss-module___EIiwG__z-navigation",
  "z-sub": "ArticleCarousel-module-scss-module___EIiwG__z-sub",
});
